import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import { SAT_BASIC_06_Schema } from './SAT_BASIC_06_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SAT_BASIC_06_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['SafetyHealthTraining', 'getSatBasic05R1', params],
    queryFn: () =>
      apiRequest(
        'post',
        Global.urls.SafetyHealthTraining.getSatBasic05R1,
        params
      ),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAT_BASIC_06_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.SafetyHealthTraining.saveSatBasic05U1,
      payload
    );
  }, options);
};
